import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from "@angular/http";
import {OrderM} from "../model/order.mobel";
import {PaymentM} from "../model/payment";
import {OrderDetailM} from "../model/order_detail.model";
import {PurchaseM} from "../model/purchase.model";
import {StockCheckM} from "../model/stock_check.model";
import {Util} from "../util/util";

@Injectable()
export class StockService {

  private order: OrderM = new OrderM();
  private payment: PaymentM = new PaymentM();

  headers = new Headers();
  options: RequestOptions;

  constructor(private http: Http) {
    this.headers.append('Content-Type', 'application/json');
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }

  reloadToken() {
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }


  getAllStockCheck(type: string, detail_type: string, searchStr: string, status: string, status_payment: string, seller_id: number = 0, shipping_id: number = 0, sales_id: number = 0, startDate: string, endDate: string, offset = 0, limit = 30, orderBy = 'desc') {
    this.reloadToken()
    return this.http.get(`/api/stock/check/list?type=${type}&detail_type=${detail_type}&searchStr=${searchStr}&status=${status}&status_payment=${status_payment}&seller_id=${seller_id}&shipping_id=${shipping_id}&sales_id=${sales_id}&startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}&orderBy=${orderBy}`, this.options).map(res => res.json());
  }

  getAllStockTrans(type: string, detail_type: string, searchStr: string, status: string, status_payment: string, seller_id: number = 0, shipping_id: number = 0, sales_id: number = 0, startDate: string, endDate: string, offset = 0, limit = 30, orderBy = 'desc') {
    this.reloadToken()
    return this.http.get(`/api/stock/trans/list?type=${type}&detail_type=${detail_type}&searchStr=${searchStr}&status=${status}&status_payment=${status_payment}&seller_id=${seller_id}&shipping_id=${shipping_id}&sales_id=${sales_id}&startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}&orderBy=${orderBy}`, this.options).map(res => res.json());
  }

  getDetailStockCheck(bill_no: string) {
    this.reloadToken()
    return this.http.get(`/api/stock/check/detail/${bill_no}`, this.options).map(res => res.json());
  }

  getDetailStockTrans(bill_no: string) {
    this.reloadToken()
    return this.http.get(`/api/stock/trans/detail/${bill_no}`, this.options).map(res => res.json());
  }

  getDetailStockCheckById(id: number) {
    this.reloadToken()
    return this.http.get(`/api/stock/check/detail/${id}`, this.options).map(res => res.json());
  }

  getDetailStockTransById(id: number) {
    this.reloadToken()
    return this.http.get(`/api/stock/trans/detail/${id}`, this.options).map(res => res.json());
  }

  createStockCheck(stockCheckM: StockCheckM) {
    this.reloadToken()
    return this.http.post(`/api/stock/check`, stockCheckM, this.options).map(res => res.json());
  }

  createStockTrans(stockCheckM: StockCheckM) {
    this.reloadToken()
    return this.http.post(`/api/stock/trans`, stockCheckM, this.options).map(res => res.json());
  }

  updateStockCheck(stockCheckM: StockCheckM) {
    this.reloadToken()
    return this.http.put(`/api/stock/check/detail/${stockCheckM.id}`, stockCheckM, this.options).map(res => res.json());
  }

  updateStockTrans(stockCheckM: StockCheckM) {
    this.reloadToken()
    return this.http.put(`/api/stock/trans/detail/${stockCheckM.id}`, stockCheckM, this.options).map(res => res.json());
  }

  updateStockCheckStatus(stockCheck_id: number, status: string) {
    this.reloadToken()
    return this.http.put(`/api/stock/check/status/${stockCheck_id}/${status}`, {}, this.options).map(res => res.json());
  }

  updateStockTransStatus(stockCheck_id: number, status: string) {
    this.reloadToken()
    return this.http.put(`/api/stock/trans/status/${stockCheck_id}/${status}`, {}, this.options).map(res => res.json());
  }

  getStockCheckStatusCount() {
    this.reloadToken()
    return this.http.get(`/api/stock/check/getStatusCount`, this.options).map(res => res.json());
  }

  getStockTransStatusCount() {
    this.reloadToken()
    return this.http.get(`/api/stock/trans/getStatusCount`, this.options).map(res => res.json());
  }


}



// WEBPACK FOOTER //
// ./src/app/services/stock.service.ts